import {Injectable, Inject} from '@angular/core';
import { CanActivate, ActivatedRoute } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import 'rxjs/add/operator/map';
import { User } from '../data-models/user.class';

@Injectable()

export class GuestAuthGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean>|boolean {
        if (this.auth.isLoggedIn()) {
            this.router.navigate(['dashboard']);
            return false;
        }

        return true;
    }
}
